import styled, { css } from 'styled-components'

interface ContainerProps {
  is_menu_open: boolean
}

export const container = styled.aside<ContainerProps>`
  background-color: ${({ theme }) => theme.colors.red};

  ${({ is_menu_open }) =>
    is_menu_open
      ? css`
          width: 15rem;
        `
      : css`
          width: 6.875rem;
        `}

  transition: width 0.3s;
  padding: 2rem 0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    background: none;
    width: 100%;
    border: none;
  }

  nav {
    flex: 1;
    width: 100%;
    height: 100%;

    ul {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  @media (max-width: 720px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    width: 100%;
    height: 5rem;
    padding: 0;
    overflow-y: auto;

    button {
      display: none;
    }

    nav {
      height: 100%;

      ul {
        flex-direction: row;
        align-items: center;
      }

      li {
        height: 100%;
        width: 6.25rem;
        max-width: 25vw;
        display: flex;
        justify-content: center;
        align-items: center;
        a {
          flex-direction: column;
          padding: 0;
          gap: 0;

          svg: {
            width: 3.25rem;
            height: 3.25rem;
          }

          span {
            display: none;
          }

          &.active {
            span {
              display: block;
            }
            &::after {
              display: none;
            }

            svg {
              width: 2.5rem;
              margin-bottom: -0.5rem;
            }
          }
        }
      }
    }
  }

  li {
    &:has(> a.active) {
      background: rgba(0 0 0 / 10%);
    }
    &:hover {
      background: rgba(0 0 0 / 10%);
    }
    a {
      width: fit-content;
      position: relative;
      padding: 1rem 1.875rem;

      display: flex;
      align-items: center;
      gap: 1.5rem;
      svg {
        fill: ${({ theme }) => theme.colors.white};
        width: 3.75rem;
        height: 3.75rem;
        transition: fill 0.3s;
      }

      span {
        font-size: 1rem;
        font-weight: 500;
        transition: color 0.3s;
      }

      &.active {
        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          bottom: 0;
          transform: translateY(-50%);

          background-color: ${({ theme }) => theme.colors.yellow};
          width: 5px;
          height: calc(100% + 0px);

          border-radius: 0 5px 5px 0;
        }

        svg {
          fill: ${({ theme }) => theme.colors.yellow};
        }

        span {
          color: ${({ theme }) => theme.colors.yellow};
        }
      }
    }
  }
`
